import { signOut } from '@/features/auth/auth'
import { clearActiveWorkspace } from '@/features/workspace/workspace'

export function AppHeader() {
  async function onSignOut() {
    clearActiveWorkspace()
    try {
      await signOut()
    } catch (e) {
      console.error('Sign out failed', e)
    }
  }

  return (
    <header
      className="sticky top-0 z-10 flex items-center justify-between border-b border-slate-800 bg-slate-950/95 px-4 py-2 backdrop-blur"
      style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top))' }}
    >
      <span className="text-sm font-semibold">Mobile Trading Pro</span>
      <button
        type="button"
        onClick={() => void onSignOut()}
        className="text-xs text-slate-400 underline underline-offset-2"
      >
        Sign out
      </button>
    </header>
  )
}
